export default "__VITE_ASSET__CSAWdou0__"